import React from "react";
import {useNavigate} from "react-router-dom";

const HeaderButtons = (props) => {
    const navigate = useNavigate();
    const loggedIn = props.loggedIn

    return (
        <div className="header-buttons">
            {loggedIn && loggedIn
                ?
                <button className="button logout link" onClick={() => navigate("/logout")}>Sign out</button>
                :
                <>
                    <button className="button logout link" onClick={() => navigate("/login")}>Login</button>
                    <button className="button logout link" onClick={() => navigate("/register")}>Register</button>
                </>
            }
        </div>
    )
}

export default HeaderButtons;